import { NexusRouteGroup } from '../components/layout/layout.types'

export const availableRoutes = (): NexusRouteGroup[] => {
  return [
    /*
    TODO: Broken after React updates - needs to be fixed before re-adding but not currently being used so deprioritized
    {
      label: 'General',
      routes: [
        {
          label: 'Vehicle Map',
          target: '/assets/inventory',
          icon: 'public',
          exact: true,
        },
        {
          label: 'Vestaboard',
          target: '/vestaboard',
          icon: 'bar_chart',
        },
      ],
    },
    */
    {
      label: 'Fleet',
      routes: [
        {
          label: 'Vehicle Inventory',
          target: '/fleet',
          icon: 'directions_car',
          exact: true,
        },
        {
          label: 'Appointments',
          target: '/fleet/tasks',
          icon: 'calendar_month',
        },
      ],
    },
    {
      label: 'Account/Billing',
      routes: [
        {
          label: 'Reservations',
          // ! In the current navigation reservations is under pmt, but does that make sense?
          target: '/fleet/reservations',
          icon: 'event_available',
        },
      ],
    },
    {
      label: 'Customer Acquisition',
      routes: [
        {
          label: 'Promos',
          target: '/promotions',
          icon: 'confirmation_number',
        },
        {
          label: 'Customers',
          target: '/customers',
          icon: 'group',
        },
      ],
    },
    {
      label: 'Nexus',
      routes: [
        {
          label: 'Team Settings',
          target: '/fleet/teamsettings',
          icon: 'settings_applications',
        },
        {
          label: 'Vehicle Media',
          target: '/fleet/vehiclemedia',
          icon: 'photo_library',
        },
        {
          label: 'Programs',
          target: '/programs',
          icon: 'category',
        },
      ],
    },
  ]
}
